<!-- @format -->

<sis-tiny-badge *ngIf="documentState === 'DRAFT'" [variant]="'accent'"> {{ "VISIBLE_DOCUMENT_STATE.DRAFT" | translate }}</sis-tiny-badge>
<sis-tiny-badge *ngIf="documentState === 'DELETED'" [variant]="'danger'">
  {{ "VISIBLE_DOCUMENT_STATE.DELETED" | translate }}</sis-tiny-badge
>
